import React from 'react'
import { useTranslation } from 'react-i18next'
import useStyles from './Style.styles'

interface IProps {
  children: React.ReactNode
}

export const Shell = ({ children }: IProps) => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  return (
    <>
      <div className={classes.body}>
        <div className={classes.main}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </>
  )
}
